import $ from 'jquery';
import GoogleMapsLoader from 'google-maps';

GoogleMapsLoader.KEY = 'AIzaSyAr0UpaNZYmIJ1woxO5o2dSQlkE-Mrr1CE';
const zoom = 16;
const elementId = 'map';
const craftApiUrl = '/company/address.json';

function loadMap(address) {
  GoogleMapsLoader.load((google) => {
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode( { 'address': address }, function(results, status) {
      if (status == google.maps.GeocoderStatus.OK) {
        const element = document.getElementById(elementId);
        const position = results[0].geometry.location;
        const map = new google.maps.Map(element, {
          center: position,
          zoom: zoom
        });
        const marker = new google.maps.Marker({
          position: position,
          map: map
        });
      } else {
        console.log('Geocode was not successful for the following reason: ' + status);
      }
    });
  });
}

$(() => {
  $.get(craftApiUrl).then((response) => {
    if (response.data && response.data[0]) {
      const address = response.data[0];
      const addressString = `${address.locationName}`
        + `${address.streetAddress} ${address.zip} ${address.zip} ${address.city}`;
      loadMap(addressString);
    }
  });
});
